/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Rest_Hr_LessInputs */

const en_ui_thresholds_rest_hr_less = /** @type {(inputs: Ui_Thresholds_Rest_Hr_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resting HR must be less than max HR`)
};

const de_ui_thresholds_rest_hr_less = /** @type {(inputs: Ui_Thresholds_Rest_Hr_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhe-HF muss kleiner als Max-HF sein`)
};

/**
* | output |
* | --- |
* | "Resting HR must be less than max HR" |
*
* @param {Ui_Thresholds_Rest_Hr_LessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_rest_hr_less = /** @type {((inputs?: Ui_Thresholds_Rest_Hr_LessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Rest_Hr_LessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_rest_hr_less(inputs)
	return de_ui_thresholds_rest_hr_less(inputs)
});